import React from "react";
import { useLocation } from "react-router-dom";
import "./Packages.css";
import explore from "../../assets/home/explore.png";
import Button from "../../components/Button/Button";
import PackageNavs from "../../components/IterinaryNavs/IterinaryNavs";

const Packages: React.FC = () => {
  const location = useLocation();
  const activeCategoryFromNav = location.state?.activeCategory || null;
  return (
    <>
      <section className="packages-section">
        <div className="packages-overlay">
          <p>the ultimate travel experience</p>
          <h2>Turn every journey into an everlasting memory</h2>
        </div>
      </section>

      <section className="explore-section">
        <p className="explore-subtitle">EXPLORE WITH US</p>
        <h1 className="explore-title">Explore BHUTAN your way</h1>
      </section>

      <PackageNavs initialCategory={activeCategoryFromNav} />

      {/* destination section */}

      <section className="destinations-section">
        <div className="destinations-content">
          <div className="destinations-text">
            <p className="destinations-subheading">Explore the extraordinary</p>
            <h2 className="destinations-heading">
              Experience the allure of BHUTAN
            </h2>
            <p>
              At Mystique Realm, we design bespoke luxury journeys shaped by our
              deep-rooted expertise and profound connection to the mystical
              heart of Bhutan. With years of intimate knowledge, we curate every
              moment to unveil hidden treasures and sacred experiences known
              only to those who truly understand this Himalayan kingdom. Let us
              guide you through the authentic essence of Bhutan on a journey
              crafted exclusively for you.
            </p>
            <ul>
              <li>
                <p>
                  Immersive encounters with timeless traditions, ancient
                  monasteries, and vibrant local festivals
                </p>
              </li>
              <li>
                <p>
                  Exclusive access to profound experiences guided by revered
                  monks, artisans, and Bhutanese elders
                </p>
              </li>
              <li>
                <p>
                  Flawless service, ensuring a seamless pilgrimage through the
                  Land of the Thunder Dragon, filled with wonder and serenity
                </p>
              </li>
            </ul>
            <Button
              buttonName="begin your journey"
              theme="dark"
              to="/contact"
            />
          </div>
          <div className="destinations-image">
            <img src={explore} alt="Bhutan Reflection Scene" />
          </div>
        </div>
      </section>
      <section>
        <div className="pack-img"></div>
      </section>

      {/* are you planning on a vacation */}
    </>
  );
};

export default Packages;
